import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import classNames from 'classnames';
import { SvgTiles, TertiaryBtn, SvgCaretRight } from '@tmapy/style-guide';
import { useLocalStorage } from '@tmapy/utils';
import { MapSwitcherItem } from './MapSwitcherItem';
import './MapSwitcher.scss';
export const MapSwitcher = (props) => {
    const [isCollapsed, setCollapsed] = useLocalStorage(`${props.appId}.MapSwitcher.isCollapsed`);
    const handleCollapseBtnClick = useCallback(() => {
        setCollapsed(!isCollapsed ? 'true' : null);
    }, [isCollapsed, setCollapsed]);
    if (props.mapSwitcher.length > 0) {
        const icon = isCollapsed ? _jsx(SvgTiles, {}) : _jsx(SvgCaretRight, {});
        return (_jsxs("div", { className: classNames({
                'msw-container': true,
                'msw-container-isCollapsed': isCollapsed,
            }), children: [props.mapSwitcher.length > 1 && (_jsx(TertiaryBtn, { unsafeClassName: 'msw-container--collapseBtn', icon: { element: icon }, onClick: handleCollapseBtnClick })), _jsx("div", { className: 'sg-a-d-f sg-a-cg-1', children: props.mapSwitcher.map((layer) => (_jsx(MapSwitcherItem, { layer: layer, layers: props.layers, dispatch: props.dispatch }, layer.layerId))) })] }));
    }
    else {
        return null;
    }
};
//# sourceMappingURL=MapSwitcher.js.map